// extracted by mini-css-extract-plugin
export default {"widget":"Widget_widget__SkuoL","title":"Widget_title__PLKor","widgetBody":"Widget_widgetBody__0oOZi"};